module.exports = __webpack_public_path__ + "images/videoCaseStudy-berriFit-whyus-photo-01.jpg?h=e30d3fac4db927a22d4040cba1e85ad4";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-whyus-photo-01.jpg
// module id = 2100
// module chunks = 12 15